import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { ROUTES } from '../server-route';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient) { }

  getCurrentPosition(): Observable<any> {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {

        const options: PositionOptions = {
          enableHighAccuracy: false,  // Use true if you need more accuracy
          timeout: 5000,              // Timeout after 5 seconds
          maximumAge: 60000           // Use cached data if it's less than 1 minute old
        };
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          },
          options
        );
      } else {
        observer.error('Geolocation is not available in this browser.');
      }
    });
    
  }

isLocationGranted(): Observable<boolean> {
  return new Observable((observer) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Emit true when location is granted
          observer.next(true);
          observer.complete();
        },
        (error) => {
          // Emit false when location is denied
          observer.next(false);
          observer.complete();
        }
      );
    } else {
      // Emit false when geolocation is not supported
      observer.next(false);
      observer.complete();
    }
  });
}

  
}